import { FC } from 'react';

import { usePage } from '@inertiajs/react';

import { Offers } from './Offers.tsx';
import { ProductBreadcrumbs } from './ProductBreadcrumbs';
import ProductOverview from './ProductOverview.tsx';
import { RelatedProducts } from './RelatedProducts.tsx';
import {
    CartonProduct,
    Offer,
    OfferProperty,
    OverviewProduct,
    ProductVersionsSummary,
} from '../../types';

type PageProps = {
    product: OverviewProduct;
    offers: Offer[];
    related_products: CartonProduct[];
    offerProperties: OfferProperty[];
    productVersions: ProductVersionsSummary | null;
};

const Show: FC = () => {
    const {
        product,
        offers,
        related_products,
        offerProperties,
        productVersions,
    } = usePage<PageProps>().props;

    return (
        <div className="container py-4 sm:py-6 md:py-8">
            <div className="mb-3 hidden sm:mb-4 lg:block">
                <ProductBreadcrumbs />
            </div>

            <ProductOverview
                product={product}
                offers={offers}
                productVersions={productVersions}
            />

            <Offers offers={offers} offerProperties={offerProperties} />

            <RelatedProducts products={related_products} />
        </div>
    );
};

export default Show;
